import type { ShouldRevalidateFunction } from '@remix-run/react';

export const shouldRevalidateLoaderData: ShouldRevalidateFunction = ({
  nextUrl,
  currentUrl,
  defaultShouldRevalidate,
  formAction,
  formData,
}) => {
  const isCreatingLogin = formAction === '/create_login';

  const isRequestingMagicLink = formData?.get('request_magic_link') === 'true';

  if (isCreatingLogin && isRequestingMagicLink) {
    return false;
  }

  if (!isCreatingLogin) {
    const currentModalParamValue = currentUrl.searchParams.get('modal');
    const nextModalParamValue = nextUrl.searchParams.get('modal');

    // Modal opening
    if (nextModalParamValue && currentUrl.pathname === nextUrl.pathname) {
      return false;
    }

    // Modal closing
    if (currentModalParamValue && !nextModalParamValue && currentUrl.pathname === nextUrl.pathname) {
      return false;
    }
  }

  return defaultShouldRevalidate;
};
